import React, { Component } from "react";
import StripeCheckout from "react-stripe-checkout";
import Button from "../../Button/Button";
import Logo from '../../../assets/logos/logo.png';
import "./Payment.css";

class Payment extends Component {

    constructor(props) {
        super(props);
        var global = require("../../../global.js");
        this.state = {
            stripe_key: global.stripe_key,
        }
    }
	componentWillMount() {
		this.total = this.props.getSignUpProductTotal();
		this.stripeTotal = this.total * 100;
	}
	render() {
		let planList = this.props.signUpParams.searchProducts.slice();

		if (planList.includes("customers")) {
			planList.splice(planList.indexOf("customers"), 1, "Recommend Customers");
		}
		if (planList.includes("acquirers")) {
			planList.splice(planList.indexOf("acquirers"), 1, "Recommend Acquirers");
		}
		if (planList.includes("targets")) {
			planList.splice(planList.indexOf("targets"), 1, "Screen Targets");
		}
		if (planList.includes("acquisition")) {
			planList.splice(planList.indexOf("acquisition"), 1, "Recommend Acquirers and Screen Targets");
		}				
		return (
			<div>
				<div className="payment-content">
					<p className="payment-info-disc">
						Please review the following information below. By subscribing to the
						following plan(s), you agree to an initial and recurring monthly
						subscription fee at the rate listed below. You may cancel your
						monthly subscription at any time.
					</p>
					<br />
					<p className="payment-info-user">
						{this.props.signUpParams.firstName &&
							this.props.signUpParams.firstName}{" "}
						{this.props.signUpParams.lastName &&
							this.props.signUpParams.lastName}{" "}
						{this.props.signUpParams.user &&
							`(${this.props.signUpParams.user})`}
					</p>
					{planList && (
						<p className="payment-info-user">{planList.join(" & ")} Plan</p>
					)}
					<p className="payment-info-user">{`$${this.total}.00/mo.`}</p>
					<br />
					<StripeCheckout
						name="FMeasure Inc."
						image={Logo}
						currency="USD"
						amount={this.stripeTotal}
						allowRememberMe={false}
						token={this.props.onToken}
						stripeKey={this.state.stripe_key}
					>
					<Button label="Pay with card" />
					</StripeCheckout>
				</div>
			</div>
		);
	}
}

export default Payment;


// WEBPACK FOOTER //
// ./src/components/SignUp/Payment/Payment.js